import Image from "next/image";
import Link from "next/link";
import { IMG } from "@/lib/data";
import { Reveal } from "../Reveal";

const ACTIONS = [
  { href: "/initiation", title: "Initiation", text: "Non licenciés. 50 €. 25 m. .22 LR et 9 mm.", image: IMG.pistol, pos: "center 12%" },
  { href: "/locations", title: "Locations", text: "18 armes. Du .22 au 7.62×39. Casque et lunettes.", image: IMG.armePcc, pos: "center 22%" },
  { href: "/rejoindre", title: "Licence", text: "Entretien, formation, QCM FFTir. Safe & protect.", image: IMG.team, pos: "center 28%" },
];

export function Works() {
  return (
    <section className="px-5 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <h2 className="font-display mb-12 text-4xl md:text-6xl">Entrer en ligne.</h2>
        </Reveal>
        <div className="grid gap-4 md:grid-cols-3">
          {ACTIONS.map((item, i) => (
            <Reveal key={item.href} delay={i * 0.08}>
              <Link href={item.href} className="hud-frame group relative block aspect-4/5 overflow-hidden">
                <Image
                  src={item.image}
                  alt=""
                  fill
                  className="object-cover transition duration-700 group-hover:scale-105"
                  style={{ objectPosition: item.pos }}
                  sizes="33vw"
                />
                <div className="absolute inset-0 bg-linear-to-t from-ink via-ink/20 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <p className="font-display text-4xl">{item.title}</p>
                  <p className="mt-2 text-sm text-paper/80">{item.text}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
